/**
 * Load external UMD module.
 * FIXME: copied from https://github.com/Source-Digital/experience-engine/blob/f1414a0be3a36df93048cabb9c685160a4a873bf/front/src/utils/external-component.js#L5
 * Move to a shared package.
 */
import loadJsScript from './load-script.ts'

const REGEX = /^\/?(.*)\.umd(?:\.min)?\.js$/

const getModuleName = (url: string): string => {
  const pathname = new URL(url).pathname
  const match = pathname.match(REGEX)
  if (match == null) throw new Error('Could not detect module name from URL.')
  return match[1]
}

/**
 * Taking idea from
 * https://markus.oberlehner.net/blog/distributed-vue-applications-loading-components-via-http/
 * @param {*} url
 */

export default async function importExternalComponent (url: string, moduleName: string): Promise<any> {
  if (url == null) throw new Error('url must be specified.')
  const name = moduleName ?? getModuleName(url)

  return await loadJsScript(url, name)
}
